// extracted by mini-css-extract-plugin
module.exports = {"modal":"HoldingPopup_modal__2_KMn"};